import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
import { SplitText } from "../gsap/SplitText.js"
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

export default {
  init() {
    $('document').mouseleave(function () {
      $('#exitFrame').foundation('open');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/downloadEbookFl.js